import { AddReviewParams, ProductListReviewsCollection, ReviewsInfo } from '@reviews/const';
import { StateUtils } from '@spartacus/core';
import { ADD_REVIEW, PRODUCT_LIST_REVIEW, REVIEWS } from '../reviews-state';

export const LOAD_REVIEWS = '[CustomCatalog] Reviews load';
export const LOAD_REVIEWS_SUCCESS = '[CustomCatalog] Reviews load success';
export const LOAD_REVIEWS_FAIL = '[CustomCatalog] Reviews load fail';

export const ADD_REVIEW_RESET = '[CustomCatalog] Reviews add reset';
export const ADD_REVIEW_LOAD = '[CustomCatalog] Reviews add';
export const ADD_REVIEW_SUCCESS = '[CustomCatalog] Reviews add success';
export const ADD_REVIEW_FAIL = '[CustomCatalog] Reviews add fail';

export const LOAD_PRODUCT_LIST_REVIEW = '[CustomCatalog] Load Product List Review';
export const LOAD_PRODUCT_LIST_REVIEW_SUCCESS = '[CustomCatalog] Load Product List Review Success';
export const LOAD_PRODUCT_LIST_REVIEW_FAIL = '[CustomCatalog] Load Product List Review Fail';

export class LoadReviews extends StateUtils.EntityLoadAction {
  readonly type = LOAD_REVIEWS;

  constructor(public productCode: string) {
    super(REVIEWS, productCode);
  }
}

export class LoadReviewsFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_REVIEWS_FAIL;

  constructor(
    public productCode: string,
    payload: any,
  ) {
    super(REVIEWS, productCode, payload);
  }
}

export class LoadReviewsSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_REVIEWS_SUCCESS;

  constructor(
    public productCode: string,
    public payload: ReviewsInfo,
  ) {
    super(REVIEWS, productCode, payload);
  }
}

export class AddReviewReset extends StateUtils.LoaderResetAction {
  readonly type = ADD_REVIEW_RESET;

  constructor() {
    super(ADD_REVIEW);
  }
}

export class AddReview extends StateUtils.LoaderLoadAction {
  readonly type = ADD_REVIEW_LOAD;

  constructor(public params: AddReviewParams) {
    super(ADD_REVIEW);
  }
}

export class AddReviewFail extends StateUtils.LoaderFailAction {
  readonly type = ADD_REVIEW_FAIL;

  constructor(public payload: any) {
    super(ADD_REVIEW, payload);
  }
}

export class AddReviewSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = ADD_REVIEW_SUCCESS;

  constructor() {
    super(ADD_REVIEW);
  }
}

export class LoadProductListReview extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_PRODUCT_LIST_REVIEW;

  constructor(public productCodes: string[]) {
    super(PRODUCT_LIST_REVIEW);
  }
}

export class LoadProductListReviewFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_PRODUCT_LIST_REVIEW_FAIL;

  constructor(public payload: any) {
    super(PRODUCT_LIST_REVIEW, payload);
  }
}

export class LoadProductListReviewSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_PRODUCT_LIST_REVIEW_SUCCESS;

  constructor(public payload: ProductListReviewsCollection) {
    super(PRODUCT_LIST_REVIEW);
  }
}

export type ReviewsAction = LoadReviews | LoadReviewsFail | LoadReviewsSuccess;
export type AddReviewAction = AddReview | AddReviewSuccess | AddReviewFail | AddReviewReset;
export type ProductListReviewAction = LoadProductListReview | LoadProductListReviewSuccess | LoadProductListReviewFail;
